import { createDecorator } from 'components/form'
import { metaPath } from 'util/metaPath'

import { ParticipanteEditableTableModel } from './ParticipanteEditableTable'

const meta = metaPath<{ [x: string]: ParticipanteEditableTableModel }>()

export const PARTICIPANTE_EDITABLE_TABLE_PREFIX = 'new'

export const participantesDecorator = createDecorator({
  field: [meta[PARTICIPANTE_EDITABLE_TABLE_PREFIX].isCidadaoParticipanteFormOpen.absolutePath()],
  updates: (value: boolean, _: string, allValues: { [x: string]: ParticipanteEditableTableModel }) => ({
    [PARTICIPANTE_EDITABLE_TABLE_PREFIX]: {
      ...allValues[PARTICIPANTE_EDITABLE_TABLE_PREFIX],
      cidadao: !value ? allValues[PARTICIPANTE_EDITABLE_TABLE_PREFIX]?.cidadao : null,
      cidadaoParticipante: value ? allValues[PARTICIPANTE_EDITABLE_TABLE_PREFIX]?.cidadaoParticipante : null,
    },
  }),
})

export const naoPossuiCpfDecorator = createDecorator({
  field: [meta[PARTICIPANTE_EDITABLE_TABLE_PREFIX].cidadaoParticipante.stNaoPossuiCpf.absolutePath()],
  updates: (value: boolean) => {
    if (value) {
      return {
        [meta[PARTICIPANTE_EDITABLE_TABLE_PREFIX].cidadaoParticipante.cpf.absolutePath()]: null,
      }
    }
    return {
      [meta[PARTICIPANTE_EDITABLE_TABLE_PREFIX].cidadaoParticipante.cns.absolutePath()]: null,
      [meta[PARTICIPANTE_EDITABLE_TABLE_PREFIX].cidadaoParticipante.justificativaNaoPossuiCpf.absolutePath()]: null,
    }
  },
})
